import { createSelector } from 'reselect'
import { AppState } from 'store/types'

/**
 *
 * @param state - the application state
 * @returns shiftAutoAcceptCertificatesReducer - the current deduction types reducer
 */
export const selectShiftAutoAcceptCertificatesReducer = (state: AppState) =>
  state.shiftAutoAcceptCertificatesReducer

/**
 * Gets the shiftAutoAcceptCertificatesReducer array from the shiftAutoAcceptCertificatesReducer reducer
 */
export const selectShiftAutoAcceptCertificates = createSelector(
  selectShiftAutoAcceptCertificatesReducer,
  shiftAutoAcceptCertificatesReducerState =>
    shiftAutoAcceptCertificatesReducerState.data,
)

/**
 * Gets the shiftAutoAcceptCertificatesReducer' isFetching from the shiftAutoAcceptCertificatesReducer reducer
 */
export const selectShiftAutoAcceptCertificatesIsFetching = createSelector(
  selectShiftAutoAcceptCertificatesReducer,
  shiftAutoAcceptCertificatesReducerState =>
    shiftAutoAcceptCertificatesReducerState.isFetching,
)

/**
 * Gets the shiftAutoAcceptCertificatesReducer' meta from the shiftAutoAcceptCertificatesReducer reducer
 */
export const selectShiftAutoAcceptCertificatesMeta = createSelector(
  selectShiftAutoAcceptCertificatesReducer,
  shiftAutoAcceptCertificatesReducerState =>
    shiftAutoAcceptCertificatesReducerState.meta,
)

/**
 * Gets the shiftAutoAcceptCertificatesReducer' pagination from the meta object
 */
export const selectShiftAutoAcceptCertificatesPagination = createSelector(
  selectShiftAutoAcceptCertificatesMeta,
  shiftAutoAcceptCertificatesReducerMeta =>
    shiftAutoAcceptCertificatesReducerMeta.pagination,
)

/**
 * Gets the shiftAutoAcceptCertificatesReducer array from the shiftAutoAcceptCertificatesReducer reducer
 */
export const selectShiftAutoAcceptCertificatesErrors = createSelector(
  selectShiftAutoAcceptCertificatesReducer,
  shiftAutoAcceptCertificatesReducerState =>
    shiftAutoAcceptCertificatesReducerState.error,
)
